import angular from 'angular'
import './games.service'
import './edit/edit.controller'

angular
  .module('pub.games', ['pub.games.edit', 'pub.games.service'])
  .controller('GamesCtrl', GamesCtrl)

/** @ngInject */
function GamesCtrl($state, $stateParams, $timeout, GameService) {
  const vm = this
  vm.channelId = $stateParams.channelId
  vm.items = []
  vm.newTitle = ''
  vm.order = null
  vm.currentItem = null

  const statusList = [
    { id: 0, name: 'Draft' },
    { id: 1, name: 'Published' },
    { id: 4, name: 'Archived' },
  ]

  vm.getStatus = function (id) {
    const statu = statusList.find((s) => s.id == id)
    return statu ? statu.name : '-'
  }

  vm.load = function () {
    GameService.getAll(vm.channelId).then(function (res) {
      if (!res.results) {
        vm.items = []
        return
      }

      vm.items = res.results
        .sort(function (a, b) {
          return a.n - b.n
        })
        .map(function (item) {
          const publishedAt = item['ts-p'] ? item['ts-p'] / 1000 : null

          return {
            ...item,
            ['ts-p']: publishedAt,
          }
        })
    })
  }

  vm.createGame = function () {
    if (!vm.newTitle) {
      swal('Please enter game title', '', 'error')
      return
    }

    $('#createGameModal').modal('hide')
    GameService.create(vm.channelId, { t: vm.newTitle, txt: '' }).then(function (res) {
      $timeout(function () {
        $state.go('pub.games.edit', {
          channelId: vm.channelId,
          gameId: res.results.id,
        })
      }, 300)
    })
  }

  vm.create = function () {
    $state.go('pub.games.create', {
      channelId: vm.channelId,
    })
  }

  vm.edit = function (item) {
    $state.go('pub.games.edit', {
      channelId: vm.channelId,
      gameId: item.id,
    })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Delete Game',
        text: 'Are you sure you want to delete this game?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        closeOnConfirm: true,
      },
      function (isConfirm) {
        if (!isConfirm) return
        GameService.remove(vm.channelId, item.id).then(function () {
          swal('Deleted!', 'Game has been deleted.', 'success')
          vm.load()
        })
      },
    )
  }

  vm.changeOrder = function (item) {
    vm.order = null
    vm.currentItem = item
    $('#modalChangeOrder').modal('show')
  }

  vm.saveOrder = function () {
    if (!vm.order) {
      swal('Please enter a valid order number', '', 'error')
      return
    }
    GameService.reorder(vm.channelId, vm.currentItem.id, vm.order).then(
      function () {
        $('#modalChangeOrder').modal('hide')
        swal('Order updated!', '', 'success')
        vm.load()
      },
      function (err) {
        swal('Error updating order', err.error?.message || '', 'error')
      },
    )
  }

  vm.load()
}
